import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Admission } from '@domain/admission';
import { CompanyRoles } from '@domain/company';
import { Textarea } from '@tremor/react';
import { validateMultiInviteText } from '@utils/validations/text-validators';

export const ControllerMultiTextArea = ({
  textareaPlaceholder,
  formName,
  offer,
  roleName,
}: {
  textareaPlaceholder: string;
  formName: string;
  offer?: Admission;
  roleName?: CompanyRoles;
}) => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext();
  return (
    <Controller
      rules={{
        required: t('errors:formFieldRequired'),
        validate: (v: string) => validateMultiInviteText({ value: v, t, offer, setValue, roleName }),
      }}
      render={({ field }) => (
        <Textarea
          className='min-h-28 placeholder:text-tertiary'
          onValueChange={field.onChange}
          placeholder={textareaPlaceholder}
        />
      )}
      name={formName}
      control={control}
    />
  );
};
